import { Pipe, PipeTransform } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { DeviceStaticDataService } from '@shared/services/device-static-data.service';

@Pipe({
  name: 'getProp',
})
export class GetPropPipe implements PipeTransform {

  transform<T>(object: T, key: keyof T): keyof T {
    return key;
  }
}

@Pipe({
  name: 'getFC',
})
export class GetFormControlPipe implements PipeTransform {
  transform<T>(form: UntypedFormGroup, object: T, controlName: keyof T): UntypedFormControl {
    return form.controls[controlName as string] as UntypedFormControl;
  }
}
